export enum Status {
  Owner = 'Owner',
  Friend = 'Friend',
  Edit = 'Edit',
}
